import Consents from "../screens/m3Screens/Consents";
import ConsentsV3 from "../screens/m3Screens/v3Screens/ConsentsV3";
import Viewer from "../screens/m3Screens/Viewer";
import AddCareContext from "../screens/m2Screens/AddCareContext";
import RegisterAbha from "../screens/m1Screens/RegisterAbha";
import RegisterAbhaV3 from "../screens/m1Screens/v3Screens/RegisterAbhaV3";
import VerifyAbha from "../screens/m1Screens/VerifyAbha";
import VerifyAbha2 from "../screens/m1Screens/VerifyAbha_New";
import GenerateAbhaByAadhaar from "../screens/m1Screens/GenerateAbhaByAadhaar";
import GenerateAbhaV3 from "../screens/m1Screens/v3Screens/NewAbhaV3";
import VerifyAbhaV3 from "../screens/m1Screens/v3Screens/VerifyAbhaV3";
import VerifyAbhaV3_old from "../screens/m1Screens/v3Screens/VerifyAbhaV3_old";
import TabViewer from "../screens/m3Screens/TabViewer";
import DemoAuthGenerateAbha from "../screens/m1Screens/demoAuthScreens/demoAuthGenerateAbha";
import DemoAuthRegisterAbha from "../screens/m1Screens/demoAuthScreens/demoAuthRegisterAbha";
import "../assets/styles/routes.css";

export const routes = [
  {
    path: "/",
    exact: true,
    sidebar: () => <div></div>,
    main: () => <h2></h2>,
  },
  //M1 Screens.....
  {
    path: "/generateabha",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container" style={{ width: "60% !important" }}>
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Ayushman Bharat Health Account</strong>
          </h4>
        </div>
        <RegisterAbha />
      </div>
    ),
  },
  {
    path: "/generateabhav3",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container registerABHA-container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Ayushman Bharat Health Account</strong>
          </h4>
        </div>
        <RegisterAbhaV3 />
      </div>
    ),
  },
  {
    path: "/newabha",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Create ABHA</strong>
          </h4>
        </div>
        <GenerateAbhaByAadhaar />
      </div>
    ),
  },
  {
    path: "/newabhav3",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Create ABHA</strong>
          </h4>
        </div>
        <GenerateAbhaV3 />
      </div>
    ),
  },
  {
    path: "/verifyabha",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Verify ABHA</strong>
          </h4>
        </div>
        <VerifyAbha />
        {/* <VerifyAbha2/> */}
      </div>
    ),
  },
  {
    path: "/verifyabhav3",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Verify ABHA</strong>
          </h4>
        </div>
        <VerifyAbhaV3 />
        {/* <VerifyAbhaV3_old/> */}
      </div>
    ),
  },
  {
    path: "/demoAuth",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Demographic Authentication Mode </strong>
          </h4>
        </div>
        <DemoAuthRegisterAbha />
      </div>
    ),
  },
  {
    path: "/demoAuthGenerateAbha",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Create ABHA with Demographics</strong>
          </h4>
        </div>
        <DemoAuthGenerateAbha />
      </div>
    ),
  },

  //M2 Screens...
  {
    path: "/addcarecontext",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Add Care Context</strong>
          </h4>
        </div>
        <AddCareContext />
      </div>
    ),
  },

  //M3 Screens...
  {
    path: "/consents",
    sidebar: () => <div></div>,
    main: () => (
      <div
        style={{
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow:
            "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
          marginTop: "50px",
        }}
        className="consentsContainer"
      >
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Consent List</strong>
          </h4>
        </div>
        <Consents />
      </div>
    ),
  },
  {
    path: "/consentsv3",
    sidebar: () => <div></div>,
    main: () => (
      <div
        style={{
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow:
            "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
          marginTop: "50px",
        }}
        className="consentsContainer"
      >
        <div className="text-center">
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>Consent List</strong>
          </h4>
        </div>
        <ConsentsV3 />
      </div>
    ),
  },
  {
    path: "/viewer",
    sidebar: () => <div></div>,
    main: () => (
      <div className="container">
        <div className="text-center">
          {/* <h4 className='header'><strong>{global.reportName}</strong></h4> */}
          <h4 className="header" style={{ background: global.primaryColour }}>
            <strong>
              {global.benificiaryName || "Patient"}'s Health Records
            </strong>
          </h4>
        </div>
        <TabViewer />
      </div>
    ),
  },
];
